import PropTypes from 'prop-types'

const FlagAR = ({ width = '22', height = '16', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath id="flag-ar-round">
        <rect width="24" height="16" rx="3" />
      </clipPath>
    </defs>
    <g clipPath="url(#flag-ar-round)">
      <rect width="24" height="16" fill="#006C35" />
      <rect x="3" y="10.5" width="18" height="1.1" rx="0.55" fill="#fff" />
      <path d="M3 10.9 l-1.4 0.5 1.4 0.5 z" fill="#fff" />
      <path
        d="M7 6.2 q1 -1 2 0 q1 1 2 0 q1 -1 2 0 q1 1 2 0"
        fill="none"
        stroke="#fff"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

FlagAR.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default FlagAR
